import React from 'react';

function Ban() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <g stroke="currentColor" strokeWidth="2" fill="none" fillRule="evenodd">
        <path d="M1 8.735c0 4.273 3.464 7.737 7.735 7.737 4.274 0 7.738-3.464 7.738-7.737C16.473 4.463 13.01 1 8.735 1 4.465 1 1 4.463 1 8.735zM4 13.93L14.93 3" />
      </g>
    </svg>
  );
}

export default Ban;
